import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';
import Button from '../../../../core/modules/common/components/Button';
import { renderTextField } from '../../../../core/modules/common/tools/FormTools';
import themeStyles from '../../../../materialUiTheme';

const SaveSelectionForm = (props) => {
  const {
    handleSubmit,
    pristine,
    submitting,
    errorMessage,
    valid,
    onCloseModal,
    field,
  } = props;

  const isDisabled = pristine || submitting || !valid;

  let translatedErrorMessage;
  if (errorMessage) translatedErrorMessage = <FormattedMessage id={errorMessage} />;

  return (
    <form onSubmit={handleSubmit} className="operator-form">
      <FormattedMessage id={`app.save.selection.form.${field}`}>
        {txt => (
          <Field
            label={txt}
            name={field}
            component={renderTextField}
            autoComplete="off"
          />
        )}
      </FormattedMessage>

      <div className="button-container">
        <Button text="app.button.cancel" onClick={onCloseModal} />
        <Button
          type="submit"
          text="app.button.save"
          disabled={isDisabled}
          style={isDisabled ? themeStyles.blueButton.disabled : themeStyles.blueButton}
        />
      </div>
      <p className="error-message">
        {translatedErrorMessage}
      </p>
    </form>
  );
};

SaveSelectionForm.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  field: PropTypes.string,
};

SaveSelectionForm.defaultProps = {
  errorMessage: '',
  field: 'name',
};

export default SaveSelectionForm;
